/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when an action has both a `debounce` and a `throttle`
 * @export
 * @class ActionInvalidDebounceThrottleMetaError
 * @extends {Error}
 */
export class ActionInvalidDebounceThrottleMetaError extends Error {
  /**
   * Creates an instance of ActionInvalidDebounceThrottleMetaError
   * @param {string} message The Error `message`
   * @memberof ActionInvalidDebounceThrottleMetaError
   */
  constructor(message) {
    super(message);
    this.name = `ActionInvalidDebounceThrottleMetaError`;
  }
}

/**
 * Called when an action has both a `debounce` and a `throttle`
 * @param {ActionAny} action The affected action
 * @returns {never} never
 */
const throwActionInvalidDebounceThrottleMetaError = (action) => {
  throw new ActionInvalidDebounceThrottleMetaError(
    stripIndent(`
    Expected "action" to specify one of the following for its meta
      "no debounce and no throttle"
      "a debounce"
      "a throttle"
    However, both "debounce" and "throttle" were provided
    Got: "${action}".
    `),
  );
};

export default throwActionInvalidDebounceThrottleMetaError;
